import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home_case.mp4'
import _imports_1 from '@/assets/home_case.png'


const _withScopeId = n => (_pushScopeId("data-v-4c673534"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_template fill_available" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = {
  class: "intro",
  padding: "0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Welcome to TaskMatrix.AI")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " By taking the advantage of both general and deep knowledge, TaskMatrix.AI is a platform that can leverage various AI models and be capable of completing various tasks. ", -1))
const _hoisted_6 = { style: {"height":"4em"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("video", {
    "x5-video-player-type": "h5",
    "x-webkit-airplay": "allow",
    "webkit-playsinline": "true",
    "x5-playsinline": "",
    playsinline: "",
    muted: "",
    loop: "",
    preload: "auto",
    autoplay: "",
    src: _imports_0,
    poster: _imports_1
  })
], -1))
const _hoisted_8 = { class: "feature_list" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isChineseIP)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.isMicrosoftEnv || _ctx.isLogin ? '/Playground' : '/KeyForm'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Get Started")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featureList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "item",
            key: index
          }, [
            _createElementVNode("img", {
              src: item.img,
              alt: ""
            }, null, 8, _hoisted_9),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.des), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}